import { render } from "./ServicesGuide.vue?vue&type=template&id=0b83dd79"
import script from "./ServicesGuide.vue?vue&type=script&lang=js"
export * from "./ServicesGuide.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__